import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Typography, Box, Tooltip, Divider } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { modifyColorOpacity } from "../../../helpers/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HeadingFlexRow = _ref => {
  let {
    heading,
    toolTip,
    legendColor,
    legendLabel,
    includeDivider
  } = _ref;
  const theme = useTheme();
  const {
    inspector,
    singleFlexRow
  } = theme;
  const {
    cardHeader
  } = inspector || {};
  const showDivider = includeDivider === undefined ? true : includeDivider;
  const renderToolTip = toolTip => {
    if (toolTip && toolTip.length > 0) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: toolTip,
        placement: "top",
        children: /*#__PURE__*/_jsx(InfoIcon, {
          sx: inspector.icon
        })
      });
    }
    return null;
  };
  const renderLegend = (legendColor, legendLabel) => {
    if (!legendLabel || legendLabel === '') {
      return null;
    }
    const color = legendColor ? modifyColorOpacity(legendColor, 1) : theme.palette.primary;
    return /*#__PURE__*/_jsx(Typography, {
      sx: cardHeader,
      color: color,
      gutterBottom: true,
      children: legendLabel
    });
  };
  const renderDivider = includeDivider => {
    if (includeDivider) {
      return /*#__PURE__*/_jsx(Divider, {});
    }
    return null;
  };

  // you must have a heading to have a header section!
  if (!heading || heading.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: singleFlexRow,
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: cardHeader,
        children: [renderToolTip(toolTip), /*#__PURE__*/_jsx(Typography, {
          sx: cardHeader,
          display: "contents",
          gutterBottom: true,
          children: heading
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: renderLegend(legendColor, legendLabel)
      })]
    }), renderDivider(showDivider)]
  });
};
HeadingFlexRow.propTypes = {
  heading: PropTypes.string,
  toolTip: PropTypes.string,
  legendLabel: PropTypes.string,
  legendColor: PropTypes.string,
  includeDivider: PropTypes.bool
};
export default HeadingFlexRow;